import apiClient from '@/services/axios'

export async function patch(calendarEntry1, calendarEntry2) {
  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setup-calendar-entries/'+ calendarEntry1 + '/swap/' + calendarEntry2, { data: { foo: "bar" } });

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to swap calendar entries.')
}
